import Lib from '../../commons/lib';

export default class Service {
  static jegyTermekUrl = window.location.origin + '/api/jegytermek/';

  static jegyEsemenyUrl = window.location.origin + '/api/jegyesemeny/';

  static jegyvasarlasUrl = window.location.origin + '/api/jegyvasarlas/';

  static telepulesUrl = window.location.origin + '/api/telepules/';

  static cegadatUrl = window.location.origin + '/api/cegadat/';

  static kultikUrl = window.location.origin + '/api/kultik/';

  static penzugyUrl = window.location.origin + '/api/penzugykozos/';

  static helyszinUrl = window.location.origin + '/api/helyszin/';

  static teremberlesUrl = window.location.origin + '/api/teremberles/';
  
  static partnerUrl = window.location.origin + '/api/partner/';

  // WYSIWYG START

  static getWysiwygImages(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.kultikUrl + 'editor/list',
          args: { requestType: 'editor-list-get' }
        }
      ],
      fnDone
    );
  }

  static uploadWysiwygImage(file, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.kultikUrl + 'editor',
          args: { requestType: 'editor-post' },
          params: { funkcioId: 420 },
          data: file
        }
      ],
      fnDone
    );
  }

  // WYSIWYG END

  static getRendelesHelyszin(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyTermekUrl + 'kiosztas/getrendeleshelyszin'
        }
      ],
      fnDone
    );
  }

  static getRendelesEsemeny(ids, esemenyKezdete, esemenyVege, esemenyCime, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyEsemenyUrl + 'esemeny/getrendelesesemenylista',
          data: {
            kvb: {
              sta: esemenyKezdete,
              end: esemenyVege
            },
            nam: esemenyCime,
            ids: ids
          }
        }
      ],
      fnDone
    );
  }

  static getMusorList(ids, esemenyKezdete, esemenyVege, esemenyCime, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyEsemenyUrl + 'esemeny/getrendelesesemenylista',
          data: {
            kvb: {
              sta: esemenyKezdete,
              end: esemenyVege
            },
            nam: esemenyCime,
            ids: ids
          }
        }
      ],
      fnDone
    );
  }

  // TEREMKIOSZTAS START

  static getTeremkiosztas(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyTermekUrl + 'kiosztas',
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addTeremkiosztas(kiosztas, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.jegyTermekUrl + 'kiosztas',
          data: kiosztas
        }
      ],
      fnDone
    );
  }

  static editTeremkiosztas(kiosztas, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyTermekUrl + 'kiosztas',
          data: kiosztas
        }
      ],
      fnDone
    );
  }

  static deleteTeremkiosztas(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.jegyTermekUrl + 'kiosztas',
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  // TEREMKIOSZTAS END

  // SZEKTOR START

  static listSzektor(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyTermekUrl + 'szektor/list'
        }
      ],
      fnDone
    );
  }

  static getSzektor(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyTermekUrl + 'szektor',
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addSzektor(szektor, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.jegyTermekUrl + 'szektor',
          data: szektor
        }
      ],
      fnDone
    );
  }

  static editSzektor(szektor, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyTermekUrl + 'szektor',
          data: szektor
        }
      ],
      fnDone
    );
  }

  static deleteSzektor(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.jegyTermekUrl + 'szektor',
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  // SZEKTOR END

  // TELEPÜLÉS START

  static listOrszag(name, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.telepulesUrl + 'orszag/list',
          params: { name: name }
        }
      ],
      fnDone
    );
  }

  static listIranyitoszam(nev, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.telepulesUrl + 'telepules/irsz',
          params: { telepulesnev: nev }
        }
      ],
      fnDone
    );
  }

  static listTelepules(irszam, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.telepulesUrl + 'telepules',
          params: { iranyitoszam: irszam }
        }
      ],
      fnDone
    );
  }

  static listCim(text, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.telepulesUrl + 'telepules/like',
          params: { text: text }
        }
      ],
      fnDone
    );
  }

  // TELEPÜLÉS END

  // JEGYELLENŐRZÉS START

  static listEsemenyek(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyEsemenyUrl + 'esemeny/control'
        }
      ],
      fnDone
    );
  }

  static validateTicket(id, eids, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyvasarlasUrl + 'control',
          data: eids,
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static kameraPreview(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'control/kamerapreview',
        }
      ],
      fnDone
    );
  }

  // JEGYELLENŐRZÉS END

  // EMAILSABLON START

  static listSablonok(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'emailsablon/list'
        }
      ],
      fnDone
    );
  }

  static getEmailInit(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'emailsablon/init'
        }
      ],
      fnDone
    );
  }

  static getSablon(tipus, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'emailsablon',
          params: { tipus: tipus }
        }
      ],
      fnDone
    );
  }

  static editSablon(sablon, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyvasarlasUrl + 'emailsablon',
          data: sablon
        }
      ],
      fnDone
    );
  }

  // EMAILSABLON END

  // CÉGADAT START

  static listAktivCegadat(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.cegadatUrl + 'search',
          params: {
            aktiv: true,
            resultclass: '46'
          },
          data: [id]
        }
      ],
      fnDone
    );
  }

  static existsNew(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.cegadatUrl + 'cegadat/existsnew',
          args: { requestType: 'cegadat-existsnew' },
          params: {
            id: id,
            datum: null
          }
        }
      ],
      fnDone
    );
  }

  // CÉGADAT END

  // RENDELÉS START

  static listRendeles(ksz, tip, all, ids, sta, end, fsta, fend, eid, ktp, fiz, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyvasarlasUrl + 'rendeles/list',
          data: {
            ksz,
            tip: tip,
            all: all,
            ekv: {
              sta: sta,
              end: end
            },
            fkv: {
              sta: fsta,
              end: fend
            },
            eid: eid,
            ids: ids,
            ktp,
            fiz
          }
        }
      ],
      fnDone
    );
  }

  static listRendelesFromMusor(nev, sta, end, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyvasarlasUrl + 'rendeles/list',
          data: {
            sor: null,
            nev: nev,
            ema: null,
            tip: null,
            all: null,
            ekv: {
              sta: sta,
              end: end
            },
            eid: null,
            ids: []
          }
        }
      ],
      fnDone
    );
  }

  static rendelesInit(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'rendeles/init',
        }
      ],
      fnDone
    );
  }

  static getRendeles(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'rendeles',
          params: {
            id: id
          }
        }
      ],
      fnDone
    );
  }

  static getRendelesPrint(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'rendeles/print',
          acceptType: 'application/json, application/octet-stream',
          responseType: 'arraybuffer',
          params: {
            id: id
          }
        }
      ],
      fnDone
    );
  }

  static getRendelesPrint1(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'rendeles/print1',
          acceptType: 'application/json, application/octet-stream',
          responseType: 'arraybuffer',
          params: {
            id: id
          }
        }
      ],
      fnDone
    );
  }

  static editRendeles(rendelesObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyvasarlasUrl + 'rendeles',
          data: rendelesObj
        }
      ],
      fnDone
    );
  }

  static deleteRendeles(id, oka, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.jegyvasarlasUrl + 'rendeles',
          data: { ids: [id], ok: oka }
        }
      ],
      fnDone
    );
  }

  static deleteRendelesJegy(id, oka, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.jegyvasarlasUrl + 'rendeles/jegy',
          data: { ids: [id], ok: oka }
        }
      ],
      fnDone
    );
  }

  static checkRendelesDelete(ids, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyvasarlasUrl + 'rendeles/delete/init',
          data: ids
        }
      ],
      fnDone
    );
  }

  static checkJegyDelete(ids, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyvasarlasUrl + 'rendeles/jegy/delete/init',
          data: ids
        }
      ],
      fnDone
    );
  }

  static getEmail(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'rendeles/getemail',
          params: {
            id: id
          }
        }
      ],
      fnDone
    );
  }

  static resendEmail(id, ema, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'rendeles/sendemail',
          params: {
            id: id,
            ema: ema
          }
        }
      ],
      fnDone
    );
  }

  static getFizetesInit(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'rendeles/fizetes/init',
        }
      ],
      fnDone
    );
  }

  static rendelesFizetes(id, fiz, pri, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyvasarlasUrl + 'rendeles/fizetes',
          acceptType: 'application/json, application/octet-stream',
          responseType: 'arraybuffer',
          params: {
            id: id,
            fiz: fiz,
            pri: pri
          }
        }
      ],
      fnDone
    );
  }

  static exportRendelesXlsx(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.jegyvasarlasUrl + 'rendeles/report/list',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      data: data
    }], fnDone);
  }

  static exportReszletesRendelesXlsx(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.jegyvasarlasUrl + 'rendeles/report/reszleteslist',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      data: data
    }], fnDone);
  }

  static exportZaras(tol, ig, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.jegyvasarlasUrl + 'rendeles/report/forgalom/xlsx',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      withFileName: true,
      data: {
        sta: tol,
        end: ig
      }
    }], fnDone);
  }

  static exportZaras2(tol, ig, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.jegyvasarlasUrl + 'rendeles/report/forgalom/xlsx2',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      withFileName: true,
      data: {
        sta: tol,
        end: ig
      }
    }], fnDone);
  }

  static exportZarasPdf(tol, ig, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.jegyvasarlasUrl + 'rendeles/report/forgalom/pdf',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      withFileName: true,
      data: {
        sta: tol,
        end: ig
      }
    }], fnDone);
  }

  static exportNapi(tol, ig, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.jegyvasarlasUrl + 'rendeles/report/nezoszam/xlsx',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      withFileName: true,
      data: {
        sta: tol,
        end: ig
      }
    }], fnDone);
  }

  static exportNapiPdf(tol, ig, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.jegyvasarlasUrl + 'rendeles/report/nezoszam/pdf',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      withFileName: true,
      data: {
        sta: tol,
        end: ig
      }
    }], fnDone);
  }

  // RENDELÉS END

  // JEGYVÁSÁRLÁS START

  static getEvent(azon, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      public: true,
      url: Service.jegyvasarlasUrl + 'event/' + azon,
    }], fnDone);
  }

  static getAdminEvent(azon, fingerprint, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.jegyvasarlasUrl + 'event/admin/' + azon,
      header: {
        Fingerprint: fingerprint
      }
    }], fnDone);
  }

  static sendPurchase(data, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      public: true,
      url: Service.jegyvasarlasUrl + 'event/purchase',
      data: data
    }], fnDone);
  }

  static sendAdminPurchase(data, isPrint, fingerprint, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.jegyvasarlasUrl + 'event/admin/purchase',
      data: data,
      params: {
        pri: isPrint
      },
      header: {
        Fingerprint: fingerprint
      }
    }], fnDone);
  }

  static sendAdminPurchasePay(data, isPrint, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.jegyvasarlasUrl + 'event/admin/purchase/pay',
      data: data,
      params: {
        pri: isPrint
      }
    }], fnDone);
  }

  static sendAdminPurchasePayPrint(data, isPrint, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.jegyvasarlasUrl + 'event/admin/purchase/pay',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      data: data,
      params: {
        pri: isPrint
      }
    }], fnDone);
  }

  static sendAdminPurchasePrint(data, isPrint, fingerprint, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.jegyvasarlasUrl + 'event/admin/purchase',
      acceptType: 'application/json, application/octet-stream',
      responseType: 'arraybuffer',
      data: data,
      params: {
        pri: isPrint
      },
      header: {
        Fingerprint: fingerprint
      }
    }], fnDone);
  }

  // JEGYVÁSÁRLÁS END

  // ÉRTÉKESÍTÉS START

  static getErtekesitesInit(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyEsemenyUrl + 'esemeny/init',
        }
      ],
      fnDone
    );
  }

  static getErtekesitesList(ids, esemenyKezdete, esemenyVege, elmult, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.jegyEsemenyUrl + 'esemeny/list',
          data: {
            kvb: {
              sta: esemenyKezdete,
              end: esemenyVege
            },
            tpe: elmult,
            ids: ids
          }
        }
      ],
      fnDone
    );
  }

  static getErtekesites(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyEsemenyUrl + 'esemeny',
          params: { id }
        }
      ],
      fnDone
    );
  }

  static getErtekesitesPay(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'event/admin/purchase/getpay',
          params: { id }
        }
      ],
      fnDone
    );
  }

  static deleteOrder(id, fingerprint, ad, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.jegyvasarlasUrl + 'event/order',
      params: {
        id: id,
        ad
      },
      header: {
        Fingerprint: fingerprint
      }
    }], fnDone);
  }

  static getDiscounts(tid, did, eid, res, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.jegyvasarlasUrl + 'event/admin/purchase/checkkedvezmeny',
          params: { tid: tid, did: did, eid: eid, res: res }
        }
      ],
      fnDone
    );
  }

  // ÉRTÉKESÍTÉS END

  // KÜLSŐ KLIENS START

  static getTimeoutMs(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'ws/timeout',
          args: { requestType: 'timeout-get' }
        }
      ],
      fnDone
    );
  }

  static getAd(fingerprint, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.helyszinUrl + 'wskliens/ad',
          args: { requestType: 'wskliens-ad' },
          header: {
            Fingerprint: fingerprint
          }
        }
      ],
      fnDone
    );
  }

  static deleteSession(sessionid, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.helyszinUrl + 'ws/kulsokliens/session',
          args: { requestType: 'session-delete' },
          params: { id: sessionid }
        }
      ],
      fnDone
    );
  }

  // KÜLSŐ KLIENS END

  // PÉNZÜGYKÖZÖS START

  static getDefaultCurrency(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.penzugyUrl + 'penznem/defaultcurrency',
          args: { requestType: 'penznem-defaultcurrency' }
        }
      ],
      fnDone
    );
  }

  // PENZÜGYKÖZÖS END

  // TEREMBERLES START

  static listTeremberles(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/list',
          args: { requestType: 'teremberles-list' }
        }
      ],
      fnDone
    );
  }

  static initTeremberles(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/init',
          args: { requestType: 'teremberles-init' },
          params: { id }
        }
      ],
      fnDone
    );
  }

  static initTeremberlesFizetes(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/init/pay',
          args: { requestType: 'teremberles-init-pay' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static initTeremberlesFizetesView(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/init/pay/view',
          args: { requestType: 'teremberles-init-pay' },
          params: { id: id }
        }
      ],
      fnDone
    );
  }

  static addTeremberles(submitObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.teremberlesUrl + 'teremberles',
          args: { requestType: 'teremberles-post' },
          data: submitObj
        }
      ],
      fnDone
    );
  }

  static modifyTeremberles(submitObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'PUT',
          url: Service.teremberlesUrl + 'teremberles',
          args: { requestType: 'teremberles-put' },
          data: submitObj
        }
      ],
      fnDone
    );
  }

  static deleteTeremberles(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'DELETE',
          url: Service.teremberlesUrl + 'teremberles',
          args: { requestType: 'teremberles-delete' },
          params: { id }
        }
      ],
      fnDone
    );
  }

  static getTeremberles(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles',
          args: { requestType: 'teremberles-get' },
          params: { id }
        }
      ],
      fnDone
    );
  }

  static searchPartner(type, text, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'search',
      args: { requestType: 'partner-search' },
      params: {
        type: type,
        text: text
      }
    }], fnDone);
  }

  static initPartnerInsert(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/initpartner',
          args: { requestType: 'partner-initbase' }
        }
      ],
      fnDone
    );
  }

  static insertPartner(helyszinId, submitObj, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'POST',
          url: Service.teremberlesUrl + 'teremberles/partner',
          args: { requestType: 'teremberles-partner' },
          data: submitObj,
          params: { 
            id: helyszinId
           }
        }
      ],
      fnDone
    );
  }

  static modifyTeremberlesFizetes(id, bizonylatszam, fizetesiModId, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: 'GET',
          url: Service.teremberlesUrl + 'teremberles/pay',
          args: { requestType: 'teremberles-pay' },
          params: {
            id: id,
            bsz: bizonylatszam,
            fiz: fizetesiModId
          }
        }
      ],
      fnDone
    );
  }

  // TEREMBERLES END
}
